import { useEffect, useRef } from 'react';

const useCleanupOnRouteChange = (keys, routePrefix) => {
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        return () => {
            if (!isMountedRef.current) {
                const currentPath = window.location.pathname;
                const shouldRemove = !currentPath.startsWith(routePrefix);
                console.log(`Unmounting - should remove ${shouldRemove}:`, shouldRemove, "Current path:", currentPath);
                if (shouldRemove) {
                    // localStorage.removeItem(key);
                    (Array.isArray(keys) ? keys : [keys]).forEach(key => {
                        localStorage.removeItem(key);
                    });
                }
            }
        };
    }, [keys, routePrefix]);
};

export default useCleanupOnRouteChange;